import { createSlice } from "@reduxjs/toolkit";
const countSlice = createSlice({
    name:'cartCount',
    initialState:{
        cartCount:0,
        bellCount:0  
     },
    reducers: {
        setTotalCartItems : (state,action) => {state.cartCount = action.payload.cartCount},
        setTotalBellItems : (state,action) => {state.bellCount = action.payload.bellCount}
     
    }
})

export const  addTotalCartItems = countSlice.actions.setTotalCartItems;
export const  addTotalBellItems = countSlice.actions.setTotalBellItems;

export default countSlice.reducer;